import { render } from "./AcceptOfferCompleting.vue?vue&type=template&id=bfd6e52e&scoped=true"
import script from "./AcceptOfferCompleting.vue?vue&type=script&lang=js"
export * from "./AcceptOfferCompleting.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyNft.scss?vue&type=style&index=0&id=bfd6e52e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd6e52e"]])

export default __exports__